"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryOrderModule = void 0;
/* eslint-disable no-restricted-globals */
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./inventory-order.less");
const store_2 = require("./store");
const distributors_1 = require("./tabs/distributors");
const distributor_inventory_list_grid_1 = require("./tabs/distributors/components/distributor-inventory-list/distributor-inventory-list-grid");
const order_history_1 = require("./tabs/order-history");
const order_review_1 = require("./tabs/order-review");
const order_rules_1 = require("./tabs/order-rules");
const order_templates_1 = require("./tabs/order-templates");
const quick_order_1 = require("./tabs/quick-order");
let InventoryOrderModule = class InventoryOrderModule extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.withPadding = true;
        // C-047
        if (!store_1.usersStore.user.value.distUser) {
            store_1.usersStore.permissions.ReadOrder &&
                this.addTab("Quick Order", () => `/order/quickorder`, /^\/order\/quickorder\/?$/, quick_order_1.QuickOrderTab);
        }
        store_1.usersStore.permissions.ReadTemplates &&
            this.addTab("Order Templates", () => `/order/templates`, /^\/order\/templates\/?$/, order_templates_1.OrderTemplatesTab);
        store_1.usersStore.permissions.ReadOrderRules &&
            this.addTab("Order Rules", () => `/order/rules`, /^\/order\/rules\/?$/, order_rules_1.OrderRulesTab);
        // C-036.1 E-026
        store_1.usersStore.permissions.ReadOrderReview &&
            this.addTab("Order History", () => `/order/history`, /^\/order\/history\/?$/, order_history_1.OrderHistoryTab);
        // C-036.1 E-026
        store_1.usersStore.permissions.ReadOrderReview &&
            this.addTab("Order Review", () => `/order/review/0`, /^\/order\/review\/(\d+)$/, order_review_1.OrderReviewTab);
        store_1.usersStore.permissions.UpdateDistributors &&
            this.addTab("Distributors", () => `/order/distributors`, /^\/order\/distributors\/?$/, distributors_1.DistributorsTab);
        // this.addRoute(
        //   "distributor-inventory",
        //   /^\/order\/distributors\/(\d+)$/,
        //   DistributorInventoryList
        // );
        this.addRoute("distributor-inventory", /^\/order\/distributors\/(\d+)$/, distributor_inventory_list_grid_1.DistributorInventoryListGrid);
    }
    componentDidMount() {
        mobx_1.autorun(() => {
            if (!store_1.usersStore.user.loading &&
                !store_1.usersStore.user.error &&
                store_1.usersStore.user.value &&
                (location.pathname === "/order" || location.pathname === "/order/")) {
                location.href = "/order/quickorder";
            }
        });
    }
    componentWillUnmount() {
        store_2.inventoryOrderStore.purchaseOrderToEdit = null;
    }
    render() {
        return (React.createElement("div", { className: "inventory-list" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory-list__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Order" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "inventory-detail__tabs" }, super.render()))));
    }
};
InventoryOrderModule = __decorate([
    mobx_react_1.observer
], InventoryOrderModule);
exports.InventoryOrderModule = InventoryOrderModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/inventory-order.tsx
// module id = 3509
// module chunks = 0